import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: 'https://caelix-backend-tksg.onrender.com/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('caelix_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('caelix_token');
    }
    return Promise.reject(err);
  }
);
